@if (!disabled) {
  <div cdkOverlayOrigin #origin="cdkOverlayOrigin">
    <div class="vitamui-input editable-field" [class.edit-mode]="editMode" (click)="enterEditMode()">
      <div class="editable-field-content">
        <label>{{ 'SHARED.EDITABLE_PARAMS.CUSTOM_SETTINGS' | translate }}</label>
        <span class="editable-field-text-content">
          @for (domain of getList(control.value) | keyvalue; track domain) {
            <div>{{ domain.key }} : {{ domain.value }}</div>
          }
        </span>
        <div class="editable-field-control mt-1">
          <app-custom-params
            [style.width.%]="90"
            [formControl]="control"
            [selectedValues]="control?.value"
            (click)="onDomainInputClick()"
            [keyPlaceholder]="'SHARED.EDITABLE_PARAMS.KEY'"
            [valuePlaceholder]="'SHARED.EDITABLE_PARAMS.VALUE'"
          >
          </app-custom-params>
        </div>
      </div>
      @if (!showSpinner && !editMode) {
        <i class="material-icons edit-icon">edit</i>
      }
      @if (showSpinner) {
        <div>
          <mat-spinner class="vitamui-spinner small"></mat-spinner>
        </div>
      }
    </div>
  </div>
  <div class="vitamui-input-errors"></div>
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOpen]="editMode"
    [cdkConnectedOverlayOrigin]="origin"
    [cdkConnectedOverlayPositions]="positions"
  >
    <div class="editable-field-actions">
      <button type="button" class="editable-field-confirm" (click)="confirm()" [disabled]="!canConfirm">
        <i class="material-icons">check</i>
      </button>
      <button type="button" class="editable-field-cancel" (click)="cancel()"><i class="material-icons">clear</i></button>
    </div>
  </ng-template>
}

@if (false) {
  <div class="read-only-field disabled-input"></div>
}
